import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { ImageLoader } from '@icecreamsocial/components';
import { useStore } from '../../hooks';
import PopsicleLoader from '../../presentational/PopsicleLoader';

/**
 * @description
 * Displays the hero image.  Image changes depending on if `store.shared` has been set to true
 *
 * @depends
 *  `store.shared`
 *  `store.Campaign`
 *
 * @usage
 * `<Hero />`
 */
export const Hero = observer(() => {
	const { Campaign, shared } = useStore();

	const offerImageURL = `${process.env.BASE_IMG_URL}/${Campaign?.offerImage}`;
	const thankYouImageURL = `${process.env.BASE_IMG_URL}/${Campaign?.thankYouImage}`;
	const hero = useMemo(() => (!shared ? offerImageURL : thankYouImageURL), [
		shared,
		offerImageURL,
		thankYouImageURL,
	]);

	return (
		<ImageLoader
			key={hero}
			srcList={hero}
			backgroundColor="body"
			elWidth="100%"
			elMinWidth="50%"
			elMinHeight="240px"
			alignSelf="stretch"
			overflow="hidden"
			position={['fixed', 'relative']}
			style={{
				objectFit: 'cover',
				objectPosition: '50% 50%',
			}}
			loader={() => <PopsicleLoader margin="auto" />}
		/>
	);
});
